import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/LINK_TO_FRAMEWORK_MODAL';
export const {action: show} = createAction(
    `${domain}/SHOW`,
    (formIdentifier, framework, variant, statementRefinements, areaRefinements, childId) => ({
        formIdentifier,
        framework,
        variant,
        statementRefinements,
        areaRefinements,
        childId,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: showAgeBandSelector} = createAction(`${domain}/SHOW_AGE_BAND_SELECTOR`, show => ({show}));

export const {action: selectArea} = createAction(`${domain}/SELECT_AREA`, (area, currentSubarea, nextSubarea) => ({
    area,
    currentSubarea,
    nextSubarea,
}));

export const {action: selectSubArea} = createAction(`${domain}/SELECT_SUB_AREA`, (subArea, currentSubarea) => ({
    subArea,
    currentSubarea,
}));

export const {action: selectAgeBand} = createAction(`${domain}/SELECT_AGEBAND`, ageBand => ({ageBand}));
